import { Button, Modal, Typography } from "@povio/ui";
import Image from "next/image";

import ModalCoverImage from "@/assets/images/modal-cover.png";

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
}
export const UnsavedChangesModal = ({ isOpen, onClose, onSave }: UnsavedChangesModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalClassName="relative"
    >
      <div className="absolute top-0 right-0 left-0 z-0 h-[142px] w-full">
        <Image
          src={ModalCoverImage}
          alt="Modal cover"
          fill
          className="object-cover"
        />
      </div>
      <div className="z-10 flex w-full flex-col gap-6">
        <Typography
          size="title-4"
          variant="prominent-1"
          className="text-center"
        >
          You have unsaved changes
        </Typography>
        <Typography
          size="body-4"
          className="text-center text-text-default-2"
        >
          Are you sure you want to leave? Your changes will be lost.
        </Typography>
        <div className="mt-1-5 flex w-full gap-3">
          <Button
            size="s"
            width="fill"
            onPress={onSave}
          >
            Continue Editing
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            size="s"
            width="fill"
            onPress={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
